import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "../../lib/api";
import { Btn, JsonDialog, Table } from "./AdminParts";

const fmt = (v) => (v ? new Date(v).toLocaleString() : "—");

export function AdminSitePayments({ api }) {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/admin/site-gateways").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => { load(); }, [load]);
  const [guide, setGuide] = useState(null);
  useEffect(() => { api.get("/admin/site-gateways/guide").then((r) => setGuide({ sections: r.data })).catch(() => {}); }, [api]);
  const saveGuide = async (v) => { const r = await api.put("/admin/site-gateways/guide", v); setGuide({ sections: r.data }); };
  const resetGuide = async () => { if (window.confirm("Reset the Razorpay guide to default?")) { const r = await api.delete("/admin/site-gateways/guide"); setGuide({ sections: r.data }); toast.success("Guide reset"); } };
  if (!rows || !guide) return null;
  return (
    <div className="space-y-6" data-testid="admin-site-payments">
      <p className="text-sm text-slate-600">Customers' own Razorpay merchant connections (separate from Altiora's billing). Secrets are encrypted and never shown here.</p>
      <Table testid="admin-site-payments-table" rows={rows} cols={[
        ["customer", "Customer"], ["project", "Website / project"],
        ["status", "Integration", (r) => <span className={`text-[11px] px-2 py-0.5 rounded-full ${r.status === "live" ? "bg-emerald-100 text-emerald-800" : r.status === "test" ? "bg-amber-100 text-amber-800" : "bg-slate-100"}`}>{r.status}</span>],
        ["verified", "Last verification", (r) => <span className="text-xs">Test: {fmt(r.test_verified)}<br />Live: {fmt(r.live_verified)}</span>],
        ["webhook", "Webhook", (r) => <span className="text-xs">{r.webhook ? `${r.webhook.event} · ${r.webhook.outcome} · ${fmt(r.webhook.at)}` : "none yet"}</span>],
        ["last_tx", "Last transaction", (r) => <span className="text-xs">{r.last_tx ? `${r.last_tx.status} · ${fmt(r.last_tx.at)}` : "—"}</span>],
        ["failed", "Failed"], ["errors", "Errors", (r) => <span className="text-xs text-red-700">{r.errors.join(" · ") || "—"}</span>],
      ]} />
      <div className="card-lux text-sm space-y-2" data-testid="admin-rzp-guide">
        <h2 className="text-xl text-[#062a20]">Razorpay setup instructions</h2>
        <p className="text-slate-600">Edit these when Razorpay changes its dashboard. Customers see changes straight away.</p>
        <div className="flex gap-2">
          <JsonDialog title="Razorpay guide (sections → title, steps)" initial={guide} onSave={saveGuide} testid="admin-rzp-guide-edit" trigger={<Btn data-testid="admin-rzp-guide-edit-btn">Edit guide</Btn>} />
          <Btn onClick={resetGuide} data-testid="admin-rzp-guide-reset">Reset to default</Btn>
        </div>
      </div>
    </div>);
}
